import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionHeaderTitle: {
    defaultMessage: 'Return Outcome Summary',
    description: 'Expander title for the return outcome summary section',
    id: 'WNANvi',
  },
  subTotalLabel: {
    defaultMessage: 'Subtotal',
    description: 'Label for the subtotal cost in the return outcome summary section',
    id: '1FIrX8',
  },
  shippingFeeLabel: {
    defaultMessage: 'Shipping Fees',
    description: 'Label for the shipping fee cost in the return outcome summary section',
    id: 'uMEnXO',
  },
  returnProcessingFeeLabel: {
    defaultMessage: 'Return Processing Fees',
    id: 'SZNed5',
    description: 'Label for the return processing fee in the cost summary',
  },
  paymentProcessingFeeLabel: {
    defaultMessage: 'Payment Processing Fees',
    id: 'lXytt7',
    description: 'Label for the payment processing fee in the cost summary',
  },
  giftCardIncentiveLabel: {
    defaultMessage: 'Gift Card Incentive',
    id: '0BcyJn',
    description: 'Label for the gift card incentive in the cost summary',
  },
  totalAmountLabel: {
    defaultMessage: 'Total Amount',
    id: 'VSl8BZ',
    description: 'Label for the total amount in the cost summary',
  },
  totalAmountDisclaimer: {
    defaultMessage: '{isRefund, select, true {Refund} other {Invoice Amount}}',
    id: 'o5RuIe',
    description: 'Disclaimer for the total amount in the cost summary to indicate that it is an estimated value',
  },
  disclaimerText: {
    defaultMessage:
      '{isRefund, select, true {Refunds} other {Exchanges}} are issued after the return is processed. Rejected items will not be exchanged or refunded.',
    description: 'Disclaimer text displayed when processing the return request',
    id: 'OWBTI5',
  },
});
